export enum SelectionMode {
    Single,
    Multiple
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/objects/enums/selection-mode.ts